export default "__VITE_ASSET__3ce52adb__"